<template>
	<StrugglesMobile v-if="isMobile" v-bind="$props" />
	<StrugglesDesktop v-else v-bind="$props" />
</template>

<script setup>
import { useScreen } from 'vue-screen'
import { useClientOnlyComputed } from '~/composables/core'
import { breakpoints } from '~/config'

import StrugglesDesktop from './StrugglesDesktop.vue'
import StrugglesMobile from './StrugglesMobile.vue'

defineProps({
	mainTitle: { type: Array, default: undefined },
	struggles: { type: Array, default: undefined },
	whatsMissing: { type: Object, default: undefined },
	enableSnap: { type: Boolean, default: false },
})

const screen = useScreen()
const isMobile = useClientOnlyComputed(false, () => screen.width <= breakpoints.xsmall, screen)
</script>
